import {
  DatasetDurationManager,
  DatasetSizeManager,
  DownloadResultManager,
} from "@/services/license/base/license-manager-abstractions";
import { StemSplitterDatasetDurationLimiter } from "@/services/license/license-limiters/dataset-duration-limiters/stem-splitter-dataset-duration-limiter";
import { StemSplitterDatasetSizeLimiter } from "@/services/license/license-limiters/dataset-size-limiters/stem-splitter-dataset-size-limiter";
import { DownloadResultLimiter } from "@/services/license/license-limiters/base-limiters/download-result-limiter";
import { TrialDownloadResultLimiter } from "@/services/license/license-limiters/download-result-limiters/trial-download-result-limiter";

export class StemSplitterLicenseManager
  implements DatasetDurationManager, DatasetSizeManager, DownloadResultManager
{
  datasetDurationLimiter = new StemSplitterDatasetDurationLimiter();
  datasetSizeLimiter = new StemSplitterDatasetSizeLimiter();
  downloadResultLimiter = new TrialDownloadResultLimiter();
}

const stemSplitterLicenseManager = new StemSplitterLicenseManager();
export { stemSplitterLicenseManager };
